(() => {
  const instances = new WeakSet();
  function init(scope = document) {
    scope.querySelectorAll('[data-product-rail]').forEach(grid => {
      if (instances.has(grid)) return;
      const cards = [...grid.children].filter(el => el.matches('.product-card, .recently-card'));
      if (!cards.length) return;
      instances.add(grid);
      if (grid.dataset.railShuffle === 'true') {
        const original = cards.slice();
        for (let i = cards.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [cards[i], cards[j]] = [cards[j], cards[i]]; }
        if (cards.length > 1 && cards.every((card, i) => card === original[i])) cards.push(cards.shift());
        grid.append(...cards);
      }
      if (cards.length <= 4) return;
      const controls = grid.parentElement.querySelector('[data-rail-controls]');
      if (!controls) return;
      controls.hidden = false; grid.classList.add('product-rail');
      const rtl = getComputedStyle(grid).direction === 'rtl';
      const offset = () => Math.abs(grid.scrollLeft);
      const jump = value => { grid.scrollLeft = rtl ? -value : value; };
      const step = () => grid.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(grid).columnGap) || 0);
      let moving = false, timer;
      // Rotate the original nodes, preserving wishlist/forms without duplicate IDs.
      function recycle() {
        if (moving || !grid.isConnected || grid.contains(document.activeElement)) return;
        const size = step(), x = offset(), max = grid.scrollWidth - grid.clientWidth;
        if (size <= 0 || max < size - 2) return;
        if (x >= max - 2) {
          moving = true; grid.append(grid.firstElementChild); jump(x - size);
          requestAnimationFrame(() => { moving = false; });
        }
      }
      controls.querySelector('[data-rail-prev]').addEventListener('click', () => {
        if (moving) return;
        const size = step();
        if (offset() < size - 2) { moving = true; grid.prepend(grid.lastElementChild); jump(offset() + size); moving = false; }
        grid.scrollBy({ left: (rtl ? 1 : -1) * size, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
      controls.querySelector('[data-rail-next]').addEventListener('click', () => { recycle(); grid.scrollBy({ left: (rtl ? -1 : 1) * step(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); });
      grid.addEventListener('scroll', () => { clearTimeout(timer); timer = setTimeout(recycle, 160); }, { passive: true });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.querySelectorAll('[data-recently-viewed-grid]').forEach(grid => new MutationObserver(() => init(grid.parentElement)).observe(grid, { childList: true }));
})();
